import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { OutlinedPushPin } from 'icons';

const PREFIX = 'FirmOption';

export const firmOptionClasses = {
  avatar: `${PREFIX}-avatar`,
};

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  '& .MuiListItem-root': {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      cursor: 'pointer',
    },
  },
  [`& .${firmOptionClasses.avatar}`]: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1.5),
    color: theme.palette.primary.main,
    fontSize: '1rem',
    fontWeight: 'bold',
    backgroundColor: theme.palette.common.white,
  },
  '&:hover .StyleOutlinedPushPin': {
    opacity: 1,
  },
}));

export const StyleOutlinedPushPin = styled(OutlinedPushPin)(() => ({
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
  '&:hover': {
    opacity: 1,
  },
}));
